// TODO: Translate this message

export function NoscriptNotification() {
  return (
    <noscript>
      <div className="g-fixed g-bottom-2 g-end-2 g-px-4 g-py-2 g-max-w-md g-bg-red-600 g-shadow-lg g-text-white g-z-[1000]">
        <p>JavaScript is needed for the full site experience</p>
      </div>
    </noscript>
  );
}
